module.exports = __webpack_public_path__ + "img/axle_conf_8.4717b798.jpg";